function hzOnReady(callback){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',callback,{once:true});}else{callback();}}

hzOnReady(function(){
  const root=document.querySelector('[data-product-root]');
  if(!root)return;
  const mainImage=document.getElementById('MainProductImage');
  // Gallery switching is initialized by HealthzeriGallery before deferred product scripts.
  const idInput=root.querySelector('[data-variant-id]');
  function syncVariant(card){root.querySelectorAll('[data-variant-card]').forEach(x=>x.classList.remove('selected'));card.classList.add('selected');idInput.value=card.querySelector('input').value;document.querySelectorAll('.yx-main-product-page [data-variant-id]').forEach(button=>{button.dataset.variantId=idInput.value;});}
  root.querySelectorAll('[data-variant-card]').forEach(card=>card.addEventListener('click',()=>syncVariant(card)));
  root.querySelectorAll('[data-purchase-tab]').forEach(tab=>tab.addEventListener('click',()=>{const key=tab.dataset.purchaseTab;root.querySelectorAll('[data-purchase-tab]').forEach(x=>x.classList.toggle('active',x===tab));root.querySelectorAll('[data-purchase-panel]').forEach(x=>x.classList.toggle('active',x.dataset.purchasePanel===key));const first=root.querySelector('[data-purchase-panel="'+key+'"] [data-variant-card]');if(first){first.querySelector('input').checked=true;syncVariant(first);}}));
  const initial=root.querySelector('input[name="variant_choice"]:checked')||root.querySelector('input[name="variant_choice"]');if(initial)syncVariant(initial.closest('[data-variant-card]'));
  let remaining=600;const counter=root.querySelector('[data-countdown]');setInterval(()=>{remaining=remaining>0?remaining-1:600;const m=Math.floor(remaining/60);const s=remaining%60;counter.textContent=String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');},1000);
});

hzOnReady(function(){
  if(window.__hzDetailInit)return;
  window.__hzDetailInit=true;
  document.querySelectorAll('[data-hz-slider]').forEach(function(slider){
    const viewport=slider.querySelector('.hz-slider__viewport');
    const track=slider.querySelector('.hz-slider__track');
    const prev=slider.querySelector('.hz-slider__arrow--prev');
    const next=slider.querySelector('.hz-slider__arrow--next');
    const dots=slider.querySelector('.hz-slider__dots');
    const originals=[...track.children].map(function(slide){return slide.cloneNode(true);});
    let current=0;
    let visible=0;
    let moving=false;

    originals.forEach(function(_,index){
      const dot=document.createElement('button');
      dot.type='button';
      dot.className='hz-slider__dot';
      dot.setAttribute('aria-label','Go to slide '+(index+1));
      dot.addEventListener('click',function(){if(!moving){current=index;update(true);}});
      dots.appendChild(dot);
    });

    function normalized(){return ((current%originals.length)+originals.length)%originals.length;}
    function updateDots(){[...dots.children].forEach(function(dot,index){dot.classList.toggle('is-active',index===normalized());});}
    function translate(animate){
      const gap=parseFloat(getComputedStyle(track).gap)||0;
      const itemWidth=(viewport.clientWidth-gap*(visible-1))/visible;
      track.style.transition=animate?'transform .42s cubic-bezier(.22,.61,.36,1)':'none';
      track.style.transform='translate3d('+(-1*(current+visible)*(itemWidth+gap))+'px,0,0)';
      updateDots();
    }
    function build(){
      const nextVisible=window.matchMedia('(max-width: 900px)').matches?1:Number(slider.dataset.desktopSlides||3);
      visible=Math.max(1,Math.min(nextVisible,originals.length));
      slider.style.setProperty('--hz-visible',visible);
      const before=originals.slice(-visible).map(function(slide){return slide.cloneNode(true);});
      const middle=originals.map(function(slide){return slide.cloneNode(true);});
      const after=originals.slice(0,visible).map(function(slide){return slide.cloneNode(true);});
      track.replaceChildren(...before,...middle,...after);
      current=normalized();
      translate(false);
    }
    function update(animate){moving=animate;translate(animate);if(animate)setTimeout(function(){
      if(current>=originals.length)current=0;
      if(current<0)current=originals.length-1;
      translate(false);moving=false;
    },440);}
    prev.addEventListener('click',function(){if(!moving){current-=1;update(true);}});
    next.addEventListener('click',function(){if(!moving){current+=1;update(true);}});
    let resizeTimer;
    window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(build,120);});
    build();
  });

  const motion=document.querySelector('.hz-product-motion');
  if(motion){
    motion.muted=true;
    const loopStart=Number(motion.dataset.loopStart||0);
    const loopEnd=Number(motion.dataset.loopEnd||0);
    function enterLoop(){if(Number.isFinite(loopStart)&&motion.currentTime<loopStart)motion.currentTime=loopStart;}
    motion.addEventListener('loadedmetadata',enterLoop);
    motion.addEventListener('timeupdate',function(){if(loopEnd>loopStart&&motion.currentTime>=loopEnd){motion.currentTime=loopStart;motion.play().catch(function(){});}});
    const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){motion.play().catch(function(){});}else{motion.pause();}});},{threshold:.15});
    observer.observe(motion);
  }
});

hzOnReady(function(){
  if(window.__healthzeriInteractionFix)return;
  window.__healthzeriInteractionFix=true;

  const mainImage=document.getElementById('MainProductImage');
  const lightbox=document.createElement('div');
  lightbox.className='hz-lightbox';
  lightbox.hidden=true;
  lightbox.setAttribute('role','dialog');
  lightbox.setAttribute('aria-modal','true');
  lightbox.setAttribute('aria-label','Image preview');
  lightbox.innerHTML='<button class="hz-lightbox__close" type="button" aria-label="Close image preview">&times;</button><figure><img class="hz-lightbox__image" alt=""><figcaption class="hz-lightbox__caption"></figcaption></figure>';
  document.body.appendChild(lightbox);
  const lightboxImage=lightbox.querySelector('.hz-lightbox__image');
  const lightboxCaption=lightbox.querySelector('.hz-lightbox__caption');
  let lastFocused=null;

  function largeImageUrl(url){
    if(!url)return '';
    return url
      .replace(/([?&])width=\d+(?=(&|$))/,'$1width=2000')
      .replace(/([?&])width=160(?=(&|$))/,'$1width=1024');
  }
  function openLightbox(url,alt,detailPan){
    if(!url)return;
    lastFocused=document.activeElement;
    lightbox.classList.toggle('is-detail-pan',!!detailPan);
    lightboxImage.src=largeImageUrl(url);
    lightboxImage.alt=alt||'Expanded product image';
    lightboxCaption.textContent=alt||'';
    lightbox.hidden=false;
    document.documentElement.classList.add('hz-lightbox-open');
    lightbox.querySelector('.hz-lightbox__close').focus();
  }
  function closeLightbox(){
    if(lightbox.hidden)return;
    lightbox.hidden=true;
    lightbox.classList.remove('is-detail-pan');
    lightboxImage.removeAttribute('src');
    document.documentElement.classList.remove('hz-lightbox-open');
    if(lastFocused&&typeof lastFocused.focus==='function')lastFocused.focus();
  }

  if(mainImage){
    mainImage.tabIndex=0;
    mainImage.setAttribute('role','button');
    mainImage.setAttribute('aria-label','Enlarge product image');
    mainImage.addEventListener('keydown',function(event){
      if(event.key==='Enter'||event.key===' '){event.preventDefault();openLightbox(mainImage.src||mainImage.currentSrc,mainImage.alt,false);}
    });
  }
  document.querySelectorAll('[data-hz-zoom]').forEach(function(container){
    container.tabIndex=0;
    container.setAttribute('role','button');
    const image=container.querySelector('img');
    container.setAttribute('aria-label','Enlarge '+((image&&image.alt)||'detail image'));
    container.addEventListener('keydown',function(event){
      if(event.key==='Enter'||event.key===' '){event.preventDefault();openLightbox(image&&(image.currentSrc||image.src),image&&image.alt,container.hasAttribute('data-hz-zoom-pan'));}
    });
  });
  lightbox.querySelector('.hz-lightbox__close').addEventListener('click',closeLightbox);
  lightbox.addEventListener('click',function(event){if(event.target===lightbox)closeLightbox();});
  document.addEventListener('keydown',function(event){if(event.key==='Escape')closeLightbox();});
  document.addEventListener('click',function(event){
    const productImage=event.target.closest&&event.target.closest('#MainProductImage');
    const detailZoom=event.target.closest&&event.target.closest('[data-hz-zoom]');
    const reviewImageLink=event.target.closest&&event.target.closest('#judgeme_product_reviews .jdgm-rev__pic-link');
    if(!productImage&&!reviewImageLink&&!detailZoom)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const reviewImage=reviewImageLink&&reviewImageLink.querySelector('img');
    const detailImage=detailZoom&&detailZoom.querySelector('img');
    const url=reviewImageLink?(reviewImage?.currentSrc||reviewImage?.src||reviewImage?.dataset.src||reviewImageLink.dataset.mfpSrc||reviewImageLink.href):(detailImage?(detailImage.currentSrc||detailImage.src):(productImage.currentSrc||productImage.src));
    const alt=reviewImageLink?(reviewImageLink.getAttribute('aria-label')||reviewImage?.alt):(detailImage?detailImage.alt:productImage.alt);
    openLightbox(url,alt,!!(detailZoom&&detailZoom.hasAttribute('data-hz-zoom-pan')));
  },true);

  const reviewRoot=document.getElementById('judgeme_product_reviews');
  if(!reviewRoot)return;

  function formatReviewDate(value){
    const date=new Date(value||'');
    if(Number.isNaN(date.getTime()))return '';
    return String(date.getMonth()+1).padStart(2,'0')+'/'+String(date.getDate()).padStart(2,'0')+'/'+date.getFullYear();
  }
  function textFromHtml(value){
    const template=document.createElement('template');
    template.innerHTML=value||'';
    return template.content.textContent||'';
  }
  function appendStars(parent,rating){
    const score=Math.max(0,Math.min(5,Number(rating)||0));
    for(let index=1;index<=5;index+=1){
      const star=document.createElement('span');
      star.className='jdgm-star '+(index<=score?'jdgm--on':'jdgm--off');
      parent.appendChild(star);
    }
  }
  function renderReview(review){
    const article=document.createElement('div');
    article.className='jdgm-rev jdgm-divider-top jdgm--done-setup';
    article.dataset.reviewId=review.uuid||'';

    const header=document.createElement('div');
    header.className='jdgm-rev__header';
    const ratingRow=document.createElement('div');
    ratingRow.className='jdgm-row-rating';
    const rating=document.createElement('span');
    rating.className='jdgm-rev__rating';
    rating.dataset.score=String(review.rating||0);
    rating.setAttribute('role','img');
    rating.setAttribute('aria-label',String(review.rating||0)+' star review');
    appendStars(rating,review.rating);
    const timestamp=document.createElement('time');
    timestamp.className='jdgm-rev__timestamp';
    timestamp.dateTime=review.created_at||'';
    timestamp.textContent=formatReviewDate(review.created_at);
    ratingRow.append(rating,timestamp);
    const profile=document.createElement('div');
    profile.className='jdgm-row-profile';
    const author=document.createElement('span');
    author.className='jdgm-rev__author';
    author.textContent=review.reviewer_name||'Customer';
    profile.appendChild(author);
    header.append(ratingRow,profile);

    const content=document.createElement('div');
    content.className='jdgm-rev__content';
    if(review.title){const title=document.createElement('b');title.className='jdgm-rev__title';title.textContent=review.title;content.appendChild(title);}
    const body=document.createElement('div');
    body.className='jdgm-rev__body';
    const paragraph=document.createElement('p');
    paragraph.textContent=review.body||textFromHtml(review.body_html);
    body.appendChild(paragraph);
    content.appendChild(body);

    if(Array.isArray(review.pictures_urls)&&review.pictures_urls.length){
      const pictures=document.createElement('div');
      pictures.className='jdgm-rev__pics';
      review.pictures_urls.forEach(function(picture,index){
        const original=picture.original||picture.huge||picture.small||'';
        const thumbnail=picture.small||picture.compact||original;
        const link=document.createElement('a');
        link.className='jdgm-rev__pic-link';
        link.href=original;
        link.setAttribute('aria-label',(review.reviewer_name||'Customer')+' review photo '+(index+1));
        const image=document.createElement('img');
        image.className='jdgm-rev__pic-img';
        image.alt=(review.reviewer_name||'Customer')+' review photo';
        image.src=thumbnail;
        image.dataset.src=thumbnail;
        link.appendChild(image);
        pictures.appendChild(link);
      });
      content.appendChild(pictures);
    }

    if(Array.isArray(review.transparency_badges)&&review.transparency_badges.length){
      const wrapper=document.createElement('div');
      wrapper.className='jdgm-rev__transparency-badge-wrapper';
      const badge=document.createElement('div');
      badge.className='jdgm-rev__transparency-badge';
      badge.textContent='Review collected from another provider';
      wrapper.appendChild(badge);
      content.appendChild(wrapper);
    }
    article.append(header,content);
    return article;
  }
  async function loadReviewPage(pageNumber,trigger){
    const pagination=reviewRoot.querySelector('.jdgm-paginate');
    const reviewsContainer=reviewRoot.querySelector('.jdgm-rev-widg__reviews');
    if(!pagination||!reviewsContainer)return;
    pagination.classList.add('hz-reviews-loading');
    trigger&&trigger.setAttribute('aria-busy','true');
    try{
      const params=window.jdgm?.ajaxParamsFor&&window.jdgm?.$?window.jdgm.ajaxParamsFor(window.jdgm.$(reviewRoot)):{
        url:window.Shopify?.shop||location.hostname,
        shop_domain:window.Shopify?.shop||location.hostname,
        platform:'shopify',
        product_id:reviewRoot.dataset.id
      };
      params.page=String(pageNumber);
      params.per_page=Number(pagination.dataset.perPage||5);
      const endpoint=new URL(pagination.dataset.url||'https://api.judge.me/reviews/reviews_for_widget');
      Object.entries(params).forEach(function(entry){if(entry[1]!==null&&entry[1]!==undefined&&entry[1]!=='')endpoint.searchParams.set(entry[0],entry[1]);});
      const response=await fetch(endpoint.toString(),{credentials:'omit',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Review request failed: '+response.status);
      const data=await response.json();
      const fragment=document.createDocumentFragment();
      (data.reviews||[]).forEach(function(review){fragment.appendChild(renderReview(review));});
      reviewsContainer.replaceChildren(fragment);
      pagination.querySelectorAll('.jdgm-paginate__page[data-page]').forEach(function(link){
        const current=String(link.dataset.page)===String(pageNumber);
        link.classList.toggle('jdgm-curt',current);
        if(current)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');
      });
      reviewsContainer.scrollIntoView({block:'start',behavior:'smooth'});
    }catch(error){
      console.error('[Healthzeri reviews] Unable to load review page',error);
    }finally{
      pagination.classList.remove('hz-reviews-loading');
      trigger&&trigger.removeAttribute('aria-busy');
    }
  }
  reviewRoot.addEventListener('click',function(event){
    const pageLink=event.target.closest&&event.target.closest('.jdgm-paginate__page[data-page]:not(.jdgm-curt)');
    if(!pageLink)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    loadReviewPage(pageLink.dataset.page,pageLink);
  },true);
});
